export const defaultState = () => ({
  topCenterContentBlock: {}
});

const state = defaultState();

export default state;
